module.exports = __webpack_public_path__ + "img/holiday_supplies_hover.1e6381bf.png";